module.exports = __webpack_public_path__ + "static/media/golfer-6-a.0d51c19d.png";